import React, { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import MembershipPlans from './components/MembershipPlans';
import ClassSchedule from './components/ClassSchedule';
import TrainerProfiles from './components/TrainerProfiles';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { useLanguage } from 'LanguageContext';

const PublicLandingPage = () => {
 const {language} = useLanguage()

  // Apply RTL class to document body when Arabic is selected
  useEffect(() => {
    if (language === 'ar') {
      document.body.classList.add('rtl');
      document.documentElement.dir = 'rtl';
    } else {
      document.body.classList.remove('rtl');
      document.documentElement.dir = 'ltr';
    }

    // Cleanup function to reset on unmount
    return () => {
      document.body.classList.remove('rtl');
      document.documentElement.dir = 'ltr';
    };
  }, [language]);

  return (
    <div className="min-h-screen">
      {/* Navigation */}
      <Navigation language={language}  />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <HeroSection language={language} />

        {/* About Section */}
        <AboutSection language={language} />

        {/* Membership Plans 
        <MembershipPlans language={language} />*/}

        {/* Class Schedule 
        <ClassSchedule language={language} />*/}

        {/* Trainer Profiles 
        <TrainerProfiles language={language} />*/}

        {/* Contact Section */}
        <ContactSection language={language} />
      </main>

      {/* Footer */}
      <Footer language={language} />
    </div>
  );
};

export default PublicLandingPage;